import { LogService } from './../../services/logging.service';
import { WarehouseService } from './Warehouse.service';
import { MayerFabricsService } from '../../services/mayer-fabrics.service';
import { InventorySummaryInquiryService } from './InventorySummaryInquiry.service';
import { UpToDateBuildService } from '../../services/up-to-date-build.service';
import { AcumaticaRequestOptions, AcumaticaService } from '../acumatica.service';
import { Injectable } from '@angular/core';
import { Observable, forkJoin, Subject } from 'rxjs';
import { KitSpecification, KitSpecificationService, KitStockComponent, KitStockComponentTypeEnum } from './KitSpecification.service';
import { SalesOrder, SalesOrderDetail, SalesOrderService } from './SalesOrder.service';
import { Customer, CustomerLocation, CustomerSampleBook, CustomerSerivce } from './Customer.service';
import { Address, DocContact } from './Contacts.service';
import { RepOrderShipToEnum } from 'src/app/common/general-components';

@Injectable({
    providedIn: 'root'
})

export class SampleBooksService extends KitSpecificationService {
    public BinderShelf: { [key: string]: BinderSpecification } = {
        'UF1': new BinderSpecification({ InventoryID: 'UF1', RevisionID: '202208', Description: 'Upholstery 1', ItemsetGroup: 'Upholstery', SortOrder: 1 }),
        'UF2': new BinderSpecification({ InventoryID: 'UF2', RevisionID: '202208', Description: 'Upholstery 2', ItemsetGroup: 'Upholstery', SortOrder: 2 }),
        'UF3': new BinderSpecification({ InventoryID: 'UF3', RevisionID: '202208', Description: 'Upholstery 3', ItemsetGroup: 'Upholstery', SortOrder: 3 }),
        'UF4': new BinderSpecification({ InventoryID: 'UF4', RevisionID: '202208', Description: 'Upholstery 4', ItemsetGroup: 'Upholstery', SortOrder: 4 }),
        'UF5': new BinderSpecification({ InventoryID: 'UF5', RevisionID: '202208', Description: 'Upholstery 5', ItemsetGroup: 'Upholstery', SortOrder: 5 }),
        'UF6': new BinderSpecification({ InventoryID: 'UF6', RevisionID: '202208', Description: 'Upholstery 6', ItemsetGroup: 'Upholstery', SortOrder: 6 }),
        'PFB': new BinderSpecification({ InventoryID: 'PFB', RevisionID: '202208', Description: 'Panel', ItemsetGroup: 'Panel', SortOrder: 7 }),
        'PCD': new BinderSpecification({ InventoryID: 'PCD', RevisionID: '202208', Description: 'Privacy Curtains & Drapery', ItemsetGroup: 'Privacy Curtains & Drapery', SortOrder: 8 }),
        'CF1': new BinderSpecification({ InventoryID: 'CF1', RevisionID: '202208', Description: 'Coated 1', ItemsetGroup: 'Coated', SortOrder: 9 }),
        'CF2': new BinderSpecification({ InventoryID: 'CF2', RevisionID: '202208', Description: 'Coated 2', ItemsetGroup: 'Coated', SortOrder: 10 }),
    };
    public get Binders(): BinderSpecification[] { return Object.values(this.BinderShelf); }

    public BinderShells: BinderShell[] = [
        { InventoryID: 'EUF1', Description: 'Upholstery 1', FullBinderID: 'UF1' },
        { InventoryID: 'EUF2', Description: 'Upholstery 2', FullBinderID: 'UF2' },
        { InventoryID: 'EUF3', Description: 'Upholstery 3', FullBinderID: 'UF3' },
        { InventoryID: 'EUF4', Description: 'Upholstery 4', FullBinderID: 'UF4' },
        { InventoryID: 'EUF5', Description: 'Upholstery 5', FullBinderID: 'UF5' },
        { InventoryID: 'EUF6', Description: 'Upholstery 6', FullBinderID: 'UF6' },
        { InventoryID: 'EPFB', Description: 'Panel', FullBinderID: 'PFB' },
        { InventoryID: 'EPCD', Description: 'Privacy Curtains & Drapery', FullBinderID: 'PCD' },
        { InventoryID: 'ECF1', Description: 'Coated 1', FullBinderID: 'CF1' },
        { InventoryID: 'ECF2', Description: 'Coated 2', FullBinderID: 'CF2' },
    ];
    public get BinderShellIDs(): string[] { return this.BinderShells.map(binder => binder.InventoryID) }

    /**
     * Find and return the BinderShell object for a given Inventory ID
     * @param inventoryID 
     * @returns BinderShell or undefined
     */
    public getBinderShell(inventoryID: string): BinderShell | undefined {
        return this.BinderShells.find(binder => binder.InventoryID == inventoryID);
    }

    /** a flag indicating the customer cards are 'loose' and not contained to specific binders */
    private _looseCards = false;
    public get LooseCards() { return this._looseCards; };
    public set LooseCards(value: boolean) { this._looseCards = value; };

    constructor(
        protected acumatica: AcumaticaService,
        private upToDate: UpToDateBuildService,
        private mayerfabrics: MayerFabricsService,
        private inventory: InventorySummaryInquiryService,
        private salesOrders: SalesOrderService,
        private customers: CustomerSerivce,
        private warehouses: WarehouseService,
        private logger: LogService
    ) {
        super(acumatica);

        this.GetAllBindersContents();
    }

    resetAuditOrder() {
        this.orderComponents = {};
        this.audit = {};
        this.order = {
            ShipToContactOverride: false,
            ShipToContact: null,
            ShipToAddressOverride: false,
            ShipToAddress: null,
            orderBinderShells: false,
            placedBinderShells: []
        };
        Object.values(this.BinderShelf).forEach(binder => binder.UserAudited = false);
    }

    /** return an object containing the details of the current audit (that can be stringified and logged) */
    public BuildAuditInfo() {
        return {
            orderComponents: this.orderComponents,
            audit: this.audit,
            order: this.order,
            binders: this.BinderShelf
        }
    }

    // #region Binder List & Contents
    public RefreshBinders(): Observable<(StoredBinderContent | null)[]> {
        this.Binders.forEach(binder => binder.StockComponents = []);
        return this.GetAllBindersContents(true);
    }

    private _getAllBinderContents?: Observable<(StoredBinderContent | null)[]>;
    public GetAllBindersContents(ignoreCache: boolean = false): Observable<(StoredBinderContent | null)[]> {
        if (ignoreCache) this._getAllBinderContents = undefined;
        if (this._getAllBinderContents) return this._getAllBinderContents;

        // binders are all fetched in a cluster of API gets
        // ensure the user login session is valid before starting them
        let allBinderGetters: Observable<StoredBinderContent | null>[] = [];

        // create the subscribers (getters) to return the forkJoin
        // but don't actually subscribe to them until after confirming the login
        this.Binders.forEach(binder => {
            let getter = this.getBinderContents(binder, ignoreCache, {
                loader: null
            });
            allBinderGetters.push(getter);
        });

        this.acumatica.CheckLogInStatus().subscribe(() => {
            allBinderGetters.forEach((getter, index) => {
                getter.subscribe((binderContent: StoredBinderContent | null) => {
                    this.Binders[index].StockComponents = binderContent?.Contents || [];
                });
            });
        });

        this._getAllBinderContents = forkJoin(allBinderGetters);

        return this._getAllBinderContents;
    }

    /**
     * returns and merges into provided binder the Card contents
     * taken from local storage if available or API fetched form Acumatica if not
     * @param binder Binder object with Inventory ID & Revision ID to fetch -- results are populated into object
     * @param ignoreCache set to true to force retrieval of specifications from acumatica
     */
    private getBinderContents(binder: BinderSpecification, ignoreCache: boolean = false, getAPIOptions?: AcumaticaRequestOptions): Observable<StoredBinderContent | null> {
        return new Observable<StoredBinderContent | null>(subscriber => {
            let key = 'BinderContent/' + binder.InventoryID;
            let contents: StoredBinderContent | null = null;

            // get localStorage contents for the given binder
            let storageJSON: string | null = localStorage.getItem(key);
            if (storageJSON !== null) {
                contents = JSON.parse(storageJSON);

                if (contents && (
                    // if content has a different Revision ID than the one hard-coded
                    (contents.RevisionID != binder.RevisionID)
                    // or content is from a different app version
                    || contents.AppVer != this.upToDate.buildNumberAtStartup
                    // or content is more than 30 days old
                    || (new Date(contents.AsOf)).addDays(30) < (new Date())
                )) {
                    localStorage.removeItem(key);
                    contents = null;
                }
            }

            // define output handler
            let output = function (contents: StoredBinderContent) {
                // sort the cards alphabetical by description
                contents.Contents.sort((a: KitStockComponent, b: KitStockComponent) => a.Description!.localeCompare(b.Description!));

                binder.StockComponents = contents.Contents;
                subscriber.next(contents);
                subscriber.complete();
            }

            // if we have it from local storage (and not told to ignore it), return it
            if (contents !== null && ignoreCache == false) {
                // when read from storage contents are generic objects -- cast into explicit types
                contents.Contents = contents.Contents.map(obj => Object.assign(new KitStockComponent(), obj));

                output(contents);
                return;
            }

            // fetch from Acumatica
            if (ignoreCache == true) {
                getAPIOptions = getAPIOptions || {};
                getAPIOptions.noCache = true;
            }

            this.get(binder.InventoryID!, binder.RevisionID!, getAPIOptions).subscribe(result => {
                // remove 'CARD' from descriptions
                result.StockComponents.forEach(card => card.Description =
                    (' ' + card.Description + ' ')
                        .replace(' CARD ', '').trim()
                        .replace(' EMPTY ', '').trim()
                        .replace('  ', ' ')
                );

                // create local storage data
                contents = {
                    RevisionID: result.RevisionID,
                    Contents: result.StockComponents,
                    AsOf: (new Date()).toISO8601(),
                    AppVer: this.upToDate.buildNumberAtStartup
                };

                // cache it in storage
                localStorage.setItem(key, JSON.stringify(contents));
                output(contents);
            }, error => {
                localStorage.removeItem(key);
                subscriber.next(null);
                subscriber.complete();
            });
        });
    }

    /**
     * search for the binder containing the given Inventory ID 
     * @param inventoryID the Inventory ID to look for
     */
    public FindContainingBinder(inventoryID: string): { Binder: BinderSpecification, Component: KitStockComponent } | null {
        let component: KitStockComponent | undefined;
        let binder: BinderSpecification | undefined;

        binder = this.Binders.find(binder => {
            component = binder.StockComponents.find((card: KitStockComponent) => card.InventoryID.trim().toUpperCase() == inventoryID.trim().toUpperCase());
            return component;
        });

        if (!binder) return null;

        return {
            Binder: binder,
            Component: component!
        };
    }
    // #endregion

    // #region Fulfillment Order
    public order: {
        customer?: Customer,
        shipToLocation?: CustomerLocation,
        shipTo?: RepOrderShipToEnum,
        /** field mapped to UI checkbox for "Order/Place Binder Shells", indicating if the rep is explicitly ordering/placing any binders */
        orderBinderShells: boolean,
        placedBinderShells: string[],
        ShipToContactOverride: boolean,
        ShipToContact: DocContact | null,
        ShipToAddressOverride: boolean,
        ShipToAddress: Address | null,
    } = {
            ShipToContactOverride: false,
            ShipToAddressOverride: false,
            ShipToContact: null,
            ShipToAddress: null,
            orderBinderShells: false,
            placedBinderShells: [],
        };

    get customerID(): string | null { return this.order.customer?.CustomerID || null };
    set customer(customer: Customer | null) {
        console.warn('binder service set customer', customer);
        if (customer == null) {
            this.order.customer = undefined;
            return;
        }
        this.order.customer = customer;

        if (this.order.shipToLocation == undefined) {
            customer.Locations = customer.Locations!
                // filter to Active locations
                .filter((location: CustomerLocation) => location.Active)
                // default / main location first
                .sort((a: CustomerLocation, b: CustomerLocation) => {
                    if (a.Default) return -1;
                    if (b.Default) return -1;
                    return a.LocationID!.localeCompare(b.LocationID!);
                });

            this.order.shipToLocation = customer.Locations[0];
        }
        console.warn('binder service set shipToLocation', this.order.shipToLocation.LocationID);
    }

    get anyShippedComponents() {
        return Object.values(this.orderComponents!).any<OrderComponent>(card => card.source == CardAuditFillSourceEnum.Shipment);
    }
    //#endregion

    // #region Card Audit working data
    public audit: {
        [inventoryID: string]: boolean
    } = {};

    /**
     * sets the indicated card as having been audited / accounted for
     * @param inventoryID the card or Inventory ID being audited
     * @param audited if the card has been found/scanned (true/default) or being removed (false)
     */
    public AuditCard(inventoryID: string | KitStockComponent, audited: boolean = true) {
        if (inventoryID instanceof KitStockComponent) {
            inventoryID = inventoryID.InventoryID;
        }

        if (audited) {
            if (this.audit[inventoryID] === undefined) {
                this.audit[inventoryID] = true;
            }
        } else {
            delete (this.audit[inventoryID]);
        }
    }

    /**
     * returns a value indicating if the specified card has been audited
     */
    public AuditStatus(inventoryID: string | KitStockComponent): boolean {
        if (inventoryID instanceof KitStockComponent) inventoryID = inventoryID.InventoryID;
        return this.audit[inventoryID] || false;
    }

    public resetAudit() { this.audit = {}; }

    /**
     * return an indication of how many cards of the total number in a given binder have been audited
     */
    public auditProgress(binder: BinderSpecification): { audited: number, total: number } {
        let cardComponents = binder.StockComponents.filter(component => component.componentType == KitStockComponentTypeEnum.Card);

        return {
            audited: cardComponents.filter(card => this.AuditStatus(card)).length,
            total: cardComponents.length
        }
    }
    // #endregion

    // #region Card Fill processing
    orderComponents: OrderComponents = {};

    /**
     * update and return the list of components to be ordered
     * (merges with previously generated audit data in case of going back to correct cards)
     */
    public getOrderComponents(): Observable<OrderComponents> {
        // binder contents must be available first which may be fetched asynchronously
        return new Observable<OrderComponents>(subscriber => {
            this.GetAllBindersContents().subscribe(() => {
                let orderComponents: OrderComponents = {};

                let checkInventory = (component: OrderComponent) => {
                    let inventoryGetters: Promise<void>[] = [];

                    // get the rep's warehouse inventory
                    if (component.RepAvail === undefined) {
                        let observer = new Promise<void>(done => {
                            this.inventory.getWhseQtyAvailable(component.kitComponent.InventoryID, this.mayerfabrics.RepWarehouseID!).subscribe(qty => {
                                component.RepAvail = qty;
                                done();
                            });
                        });
                        inventoryGetters.push(observer);
                    }

                    // get the Mayer warehouse inventory
                    if (component.RepAvail === undefined) {
                        let observer = new Promise<void>(done => {
                            this.inventory.getWhseQtyAvailable(component.kitComponent.InventoryID, '03').subscribe(qty => {
                                component.WhseAvail = qty;
                                done();
                            });
                        });
                        inventoryGetters.push(observer);
                    }

                    Promise.all(inventoryGetters).then(() => {
                        component.inventoryAvailable.next();
                        component.inventoryAvailable.complete();
                    });
                }

                // iterate audited binders
                this.Binders.filter(binder => binder.UserAudited).forEach(binder => {
                    // each card that is not marked as having been audited
                    binder.StockComponents.filter(card => this.audit[card.InventoryID] != true).forEach(card => {
                        // initialize missingComponent object and add to dictionary
                        let previousEntry = this.orderComponents[card.InventoryID];
                        let missingCard = orderComponents[card.InventoryID] = new OrderComponent(card,
                            {
                                // use existing object's data if available
                                source: previousEntry?.source || CardAuditFillSourceEnum.Unspecified,
                                RepAvail: previousEntry?.RepAvail,
                                WhseAvail: previousEntry?.WhseAvail,
                                containingBinder: binder,
                            });

                        checkInventory(missingCard);
                    });
                });

                // also include all the empty binder shells
                this.BinderShells.forEach(shell => {
                    let previousEntry = this.orderComponents[shell.InventoryID];
                    if (previousEntry === undefined) {
                        let container = this.FindContainingBinder(shell.InventoryID);
                        if (container) {
                            let orderShell = orderComponents[shell.InventoryID] = new OrderComponent(container!.Component, {
                                source: CardAuditFillSourceEnum.Omit,
                                containingBinder: container.Binder,
                            });
                            checkInventory(orderShell);
                        } else {
                            console.warn('Unable to locate Empty Binder Shell item within Kit Specifications', shell.InventoryID);
                        }
                    } else {
                        orderComponents[shell.InventoryID] = previousEntry;
                    }
                })

                this.orderComponents = orderComponents;
                subscriber.next(orderComponents);
                subscriber.complete();
            });

        });
    }
    // #endregion

    // #region Order placement
    get anyComponentsOnOrder(): boolean {
        return Object.values(this.orderComponents)
            // filter to components that are Cards or accept any when ordering Binder Shells
            .filter(component => component.kitComponent.componentType == KitStockComponentTypeEnum.Card || this.order.orderBinderShells)
            // exclude items being Omitted (or unspecified) -- only those with shipment fill source specified
            .filter(component => component.source == CardAuditFillSourceEnum.Shipment || component.source == CardAuditFillSourceEnum.SalesRep)
            .length > 0
    }

    createSalesOrder(): Observable<SalesOrder> {
        return new Observable<SalesOrder>(subscriber => {
            // create the Sales Order document
            let so = new SalesOrder({
                OrderType: 'SO',
                CustomerID: this.order.customer?.CustomerID,
                LocationID: this.order.shipToLocation!.LocationID,
                PreferredWarehouseID: '03',
            });

            // fill in order line details (async function as it may need to run after completion of 'fetch sales rep warehouse')
            let fillShipmentDetail = () => {
                so.Details = [];
                Object.values(this.orderComponents)
                    // filter to components that are Cards or accept any when ordering Binder Shells
                    .filter(component => component.kitComponent.componentType == KitStockComponentTypeEnum.Card || this.order.orderBinderShells)
                    // exclude items being Omitted -- only those with shipment fill source specified
                    .filter(component => component.source == CardAuditFillSourceEnum.Shipment || component.source == CardAuditFillSourceEnum.SalesRep)
                    .forEach(component => {
                        let warehouseID: string;
                        switch (component.source) {
                            case CardAuditFillSourceEnum.Omit:
                            case CardAuditFillSourceEnum.Unspecified:
                                return;
                            case CardAuditFillSourceEnum.SalesRep:
                                warehouseID = this.mayerfabrics.RepWarehouseID!
                                break;
                            case CardAuditFillSourceEnum.Shipment:
                                warehouseID = '03';
                                break;
                        }

                        so.Details!.push(new SalesOrderDetail({
                            InventoryID: component.kitComponent.InventoryID,
                            WarehouseID: warehouseID,
                            OrderQty: 1
                        }));
                    });

                this.logger.log(this.acumatica.username, ['Binder Audit SO'], JSON.stringify(so));

                this.salesOrders.put(so, { loader: "Creating Sales Order" }).subscribe(so => {
                    subscriber.next(so);
                    subscriber.complete();
                });
            };

            // set the ship-to
            if (this.order.ShipToContactOverride) {
                so.ShipToContactOverride = true;
                so.ShipToContact = new DocContact({
                    BusinessName: this.order.ShipToContact!.BusinessName,
                    Attention: this.order.ShipToContact!.Attention,
                    Phone1: this.order.ShipToContact!.Phone1,
                    Email: this.order.ShipToContact!.Email?.toLowerCase()
                });
            }

            if (this.order.ShipToAddressOverride) {
                so.ShipToAddressOverride = true;
                so.ShipToAddress = new Address({
                    AddressLine1: this.order.ShipToAddress!.AddressLine1,
                    AddressLine2: this.order.ShipToAddress!.AddressLine2,
                    City: this.order.ShipToAddress!.City,
                    State: this.order.ShipToAddress!.State,
                    PostalCode: this.order.ShipToAddress!.PostalCode,
                    Country: this.order.ShipToAddress!.Country,
                })
            }

            switch (this.order.shipTo) {
                case undefined:
                    so.Description = "Binder/Card placement by Sales Rep"
                    fillShipmentDetail();
                    break;
                case RepOrderShipToEnum.Customer:
                    let hasBinderShells = false;
                    let hasCards = false;
                    let binderInventoryIDs = this.BinderShellIDs;
                    Object.keys(this.orderComponents).forEach(inventoryID => {
                        if (binderInventoryIDs.contains(inventoryID)) {
                            hasBinderShells = true;
                        } else {
                            hasCards = true;
                        }
                    })

                    // * Mayer Fabrics Binders *
                    // * Mayer Fabrics Binders & Cards *
                    // * Mayer Fabrics Cards *
                    so.Description = "* Mayer Fabrics " +
                        (hasBinderShells ? "Binders " : "") +
                        (hasBinderShells && hasCards ? "& " : "") +
                        (hasCards ? "Cards " : "") + "*";
                    fillShipmentDetail();
                    break;
                case RepOrderShipToEnum.SalesRep:
                    so.Description = "Binder Cards for Customer: " + this.order.customer!.CustomerIDName;

                    // fetch the warehouse / rep address
                    this.warehouses.get(this.mayerfabrics.RepWarehouseID!, { loader: "Getting Ship-To Address" }).subscribe(warehouse => {
                        so.ShipToContactOverride = true;
                        so.ShipToContact = new DocContact({
                            BusinessName: warehouse.AccountName,
                            Attention: warehouse.Attention,
                            Phone1: warehouse.Phone1,
                            Email: warehouse.Email?.toLowerCase()
                        });

                        so.ShipToAddressOverride = true;
                        so.ShipToAddress = new Address({
                            AddressLine1: warehouse.AddressLine1,
                            AddressLine2: warehouse.AddressLine2,
                            City: warehouse.City,
                            State: warehouse.State,
                            PostalCode: warehouse.PostalCode,
                            Country: warehouse.Country,
                        });

                        so.OrderedBy = warehouse.Attention || warehouse.AccountName;
                        so.EmailAddress = warehouse.Email?.toLowerCase();
                        so.Phone = warehouse.Phone1;

                        fillShipmentDetail();
                    });
                    break;
            }
        });
    }

    /**
     * Indicate if a given BinderShell object or Inventory ID is contained within the order's placedBinderShells
     */
    binderShellOrderStatus(binder: string | BinderShell) {
        if (!(typeof binder == 'string')) binder = binder.InventoryID;
        return this.order.placedBinderShells.indexOf(binder) > -1;
    }

    toggleShellOrderStatus(binder: string | BinderShell) {
        if (!(typeof binder == 'string')) binder = binder.InventoryID;
        var isPlaced = this.binderShellOrderStatus(binder);
        if (isPlaced) this.order.placedBinderShells.remove(binder);
        else this.order.placedBinderShells.push(binder);
    }

    get anyEmptyBinderShells() { return this.order.placedBinderShells.length > 0; }
    // #endregion

    // #region Customer Sample Book Audit details
    UpdateCustomerSampleBooks(): Observable<void> {
        return new Observable<void>(subscriber => {

            // get Customer's current sample book data
            this.customers.get(this.order.customer!.CustomerID!, {
                expand: 'SampleBooks',
                loader: "Getting Current Sample Books",
                noCache: true,
            }).subscribe(currentCustomer => {

                // create a new minimal Customer object to update sample books
                let updateCustomer: {
                    CustomerID: string,
                    SampleBooks: CustomerSampleBook[]
                } = {
                    CustomerID: this.order.customer!.CustomerID!,
                    SampleBooks: []
                };

                // create a combined list of Binders the user has Audited...
                let updateCustomerBookIDs: string[] = this.Binders.filter(binder => binder.UserAudited).map(binder => binder.InventoryID!);
                // and Binder Shells the user is placing
                if (this.order.orderBinderShells) {
                    let binderInventoryIDs = this.BinderShellIDs;
                    let placedBinderShells = Object.keys(this.orderComponents)
                        .filter(inventoryID =>
                            this.orderComponents[inventoryID].source != CardAuditFillSourceEnum.Omit
                            && binderInventoryIDs.contains(inventoryID)
                        )
                        .map(inventoryID => this.getBinderShell(inventoryID)!.FullBinderID);
                    updateCustomerBookIDs = updateCustomerBookIDs.concat(placedBinderShells).unique();
                }

                // for all of the audited or newly placed binders
                updateCustomerBookIDs.forEach(binderID => {
                    // look for the new/audited binder in the customer's existing list of binders
                    let sampleBook = currentCustomer.SampleBooks!.find(book => book.InventoryID == binderID);

                    // if the customer does not already have this binder
                    if (sampleBook === undefined) {
                        // create a new entry for it in the customer's sample books
                        sampleBook = new CustomerSampleBook({
                            Active: true,
                            InventoryID: binderID
                        });
                    }
                    // update the audited LastCheck date/time
                    sampleBook.LastChecked = new Date();
                    updateCustomer.SampleBooks.push(sampleBook);
                });

                // update the customer audit info
                this.customers.put(new Customer(updateCustomer), { loader: null }).subscribe(
                    () => { subscriber.next(); subscriber.complete(); },
                    err => { subscriber.error(err); subscriber.complete(); }
                );

            });
        });
    }
    // #endregion
}

export interface BinderShell {
    InventoryID: string,
    Description: string,
    FullBinderID: string
}

export class BinderSpecification extends KitSpecification {
    constructor(init?: Partial<BinderSpecification>) {
        super({});
        if (init) Object.assign(this, init);
    }

    UserAudited: boolean = false;
    ItemsetGroup?: string;
    SortOrder!: number;
}

export interface StoredBinderContent {
    RevisionID: string,
    Contents: KitStockComponent[],
    AsOf: string,
    AppVer: string
}

export enum CardAuditFillSourceEnum {
    Unspecified,
    Omit,
    SalesRep,
    Shipment,
}

export interface OrderComponents {
    [inventoryID: string]: OrderComponent
};

export class OrderComponent {
    kitComponent: KitStockComponent;
    source: CardAuditFillSourceEnum = CardAuditFillSourceEnum.Unspecified;
    RepAvail?: number;
    WhseAvail?: number;
    inventoryAvailable = new Subject();
    containingBinder?: BinderSpecification;

    constructor(component: KitStockComponent, init: Partial<OrderComponent>) {
        this.kitComponent = component;
        Object.assign(this, init);
    }
}
